module.exports = __webpack_public_path__ + "img/2.303c4742.png";